<template>
  <div ref="loadMoreRef" class="text-center py-7">
    <slot>
      <EllipsisLoader class="ellipsis-loader" />
    </slot>
  </div>
</template>
<script setup lang="ts">
import { ref, watch, watchEffect } from 'vue'
import useObservers from '@/hooks/observers'
import { EllipsisLoader } from '../loaders'

const props = defineProps<{
  loadedListLength: number
  totalListLength: number
}>()

const emit = defineEmits(['load-more'])

const loadMoreRef = ref()
const observerMixin = useObservers()

const initializeLoadMoreObserver = (target: HTMLDivElement, callback: () => void) => {
  observerMixin.initializeIntersectionObserver(target, callback)
}

watchEffect(() => {
  if (loadMoreRef.value) {
    initializeLoadMoreObserver(loadMoreRef.value, () => emit('load-more'))
  }
})

watch(
  () => props.loadedListLength,
  (listLength, oldListLength): any => {
    const target = loadMoreRef.value
    if (!target) return

    if (listLength === 0) {
      observerMixin.observer.value?.unobserve(target)
    } else if (listLength === props.totalListLength) {
      observerMixin.observer.value?.unobserve(target)
    } else if (listLength < props.totalListLength) {
      observerMixin.observer.value?.observe(target)
    }
  }
)
</script>
<style scoped lang="scss">
.ellipsis-loader {
  margin-bottom: 150px;
}
</style>
